module.exports = __webpack_public_path__ + "images/Premium_White_Vertical.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo/Premium_White_Vertical.svg
// module id = 139
// module chunks = 0